// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__33pq9","tab":"Tabs_tab__3iMb3","tabActive":"Tabs_tabActive__1VyXF"};